export default __webpack_public_path__ + "static/media/fross3.0200a51c.png";